import { render } from "./RiskyStockTable.vue?vue&type=template&id=31baf5f7&scoped=true"
import script from "./RiskyStockTable.vue?vue&type=script&lang=js"
export * from "./RiskyStockTable.vue?vue&type=script&lang=js"

import "./RiskyStockTable.vue?vue&type=style&index=0&id=31baf5f7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31baf5f7"]])

export default __exports__